import ModalCEFeature from './ModalCEFeature'
import { FeatureModelTypeExtended } from './types'
import FeaturesValues from './FeatureValues'
import { useLocation, useParams } from 'react-router'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import DoubleTable from '../../../../../../baseComponents/DoubleTable'
import { useAddDoubleTableGreenRowRender } from '../../../../../../baseComponents/DoubleTable/functions'
import { TwinTableLink } from '../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { DeleteRow, EditRowNotLink } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { getBasePath } from '../../../../../../utils/globals/link'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import ModalDeleteFeature from './ModalDeleteFeature'

interface FeaturesProps extends ComponentWithPermissions { }

const Features: React.FC<FeaturesProps> = ({ userPermissions }) => {
    const { FeatureId } = useParams()
    return (<DoubleTable userPermissions={userPermissions} FirstChild={FeaturesInner} SecondChild={FeaturesValues} displaySecond={FeatureId !== 'main'} />)
}


const FeaturesInner: React.FC<FeaturesProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('features', 'Características'),
        newText: t('newFeature', 'Nueva característica'),
    }
    return (
        <BaseScreenTable TableComponent={TableFeature} CreateModalComponent={ModalCEFeature} EditModalComponent={ModalCEFeature} DeleteModalComponent={ModalDeleteFeature} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableFeatureProps extends TableComponentProps { }

const TableFeature: React.FC<TableFeatureProps> = ({ setTableInstance, userPermissions, setOpened }) => {
    const { t } = useTwinTranslation()
    const { FeatureId } = useParams()
    const location = useLocation()
    const basePath = getBasePath(location.pathname, 'features')
    const {rowRenderer} = useAddDoubleTableGreenRowRender(FeatureId || '')
    const columns: ColumnTableSchema<FeatureModelTypeExtended> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
            width: 75
        },
        {
            id: 'name',
            dataKey: 'FeatureLangs.name',
            label: t('name', 'Nombre'),
            minWidth: 130,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRowNotLink key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTableLink createRowDataLink={[basePath, ['$id']]} name='features' columns={columns} getDataFrom='/api/app/product/feature/getAllFeatures' setTableInstance={setTableInstance} rowRenderer={rowRenderer} hideLoadFiltersButton={true} />
    )
}


export default Features